import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { STATS_UPB_MATCH_BAND } from 'lib/networking/endpoints';

/**
 * useUpbMatchBand — fetches the top partners within a single match-rate band.
 *
 * Returns { data, loading, error, refetch }
 * data shape: { band, label, total, data: [{ entity_id, name, cnd_id, match_pct, band,
 *   upb_matched_count, denominator }] }
 */
function useUpbMatchBand({ bandIndex, limit = 10, influencedOnly = false, skip = false } = {}) {
  const url =
    bandIndex === null || bandIndex === undefined
      ? STATS_UPB_MATCH_BAND
      : `${STATS_UPB_MATCH_BAND}/${bandIndex}`;
  const params = useMemo(
    () => ({ limit, influenced_only: influencedOnly }),
    [limit, influencedOnly],
  );
  return useGet(url, params, skip || bandIndex === null || bandIndex === undefined);
}

export default useUpbMatchBand;
